import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facility } from 'src/app/services/firebase-utilities.service';

export type PatientIdCardVariant = 'default' | 'current';

@Component({
    selector: 'app-patient-id-card',
    templateUrl: './patient-id-card.component.html',
    styleUrls: ['./patient-id-card.component.scss'],
    standalone: false
})
export class PatientIdCardComponent {
  @Input() facility: Facility | undefined = undefined;
  @Input() patientId: { facility: string; value: string } | null = null;
  @Input() clickable = false;
  @Input() selected = false;
  @Input() variant: PatientIdCardVariant = 'default';
  @Input() showClickHint = false;

  @Output() cardSelected: EventEmitter<{ facility: string; value: string }> = new EventEmitter();

  handleClick(): void {
    if (!this.clickable || !this.patientId) {
      return;
    }
    this.cardSelected.emit(this.patientId);
  }

  get cardClasses(): Record<string, boolean> {
    return {
      'patient-id-card': true,
      clickable: this.clickable,
      selected: this.selected,
      'current-facility': this.variant === 'current'
    };
  }
}

